import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { PwaService } from './pwa.service';
import { ROUTE_PATHS } from '@constants/routes';
import { environment } from '../../environments/environment';

export const pwaMarketingRedirectGuard = (): boolean => {
  const authService = inject(AuthService);
  const pwaService = inject(PwaService);
  const router = inject(Router);

  if (environment.whiteLabelConfig || authService.isAuthenticated()) {
    return true;
  }

  if (pwaService.isRunningAsPWA()) {
    router.navigate([ROUTE_PATHS.AUTH_REFERRER_LOGIN], { replaceUrl: true });
    return false;
  }

  return true;
};
